import type { Audit } from "@/types";
import { formatDateTime } from "./formatters";

export function auditTimeLabel(audit: Pick<Audit, "status" | "started_at" | "finished_at"> & { created_at?: string }) {
  if (audit.status === "running") {
    return audit.started_at ? `Running since ${formatDateTime(audit.started_at)}` : "Starting...";
  }

  if (audit.status === "queued") {
    return audit.created_at ? `Queued ${formatDateTime(audit.created_at)}` : "";
  }

  if (audit.status === "failed") {
    return audit.finished_at ? `Failed ${formatDateTime(audit.finished_at)}` : "Failed";
  }

  if (audit.status === "completed") {
    return audit.finished_at ? `Completed ${formatDateTime(audit.finished_at)}` : "Completed";
  }

  return audit.finished_at ? `Cancelled ${formatDateTime(audit.finished_at)}` : "Cancelled";
}
